import "./About.css"

function About() {
    return (
      <section className="about-section">
        <div>
          <div>
            <h2>About US</h2>
            <img src="https://media.gq.com/photos/646fdd946cbe43aa644cd88b/16:9/w_1280,c_limit/shoes-art.jpg" alt="shoes" />
          </div>
          <div>
            <h2>OUR STORY</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed viverra vitae est in luctus. Proin laoreet lacus nec mattis semper. In semper tortor ex, quis pharetra felis interdum ac. Quisque sit amet urna ex.  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed viverra vitae est in luctus. Proin laoreet lacus nec mattis semper. </p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed viverra vitae est in luctus. Proin laoreet lacus nec mattis semper. In semper tortor ex, quis pharetra felis interdum ac. Quisque sit amet urna ex.  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed viverra vitae est in luctus. Proin laoreet lacus nec mattis semper. </p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed viverra vitae est in luctus. Proin laoreet lacus nec mattis semper. </p>
          </div>
        </div>
        
        <div>
          <div>
            <h3>Our Mission</h3>
            <p>Our mission is to redefine your shoe shopping experience. We believe that shoes are more than just accessories—they're a reflection of your style and personality.</p>
          </div>
          <div>
          <h3>Our Vision</h3>
            <p>Our mission is to redefine your shoe shopping experience. We believe that shoes are more than just accessories—they're a reflection of your style and personality.</p>
          </div>
          <div>
          <h3>Our Values</h3>
            <p>Our mission is to redefine your shoe shopping experience. We believe that shoes are more than just accessories—they're a reflection of your style and personality.</p>
          </div>
        </div>

        <div>
          <h2>OUR COMMUNITY</h2>
          <p>Beyond selling shoes, we're passionate about building a community of shoe enthusiasts. Connect with us through our blog, social media channels, and exclusive events. Share your stories, style tips, and love for footwear with a community that celebrates individuality and fashion.</p>
        </div>

        <img src="https://i.imgur.com/NndepLM.png" alt="shoe-community" />

      </section>
    );
}
  
export default About;